// SIL-717: extracted out of AppShell.tsx. Already pure — no React imports.
// SIL-2139: -v2 drops stale 'true' values written while the toggle did nothing
// visible on panel-less routes, so everyone starts expanded.
export const COLLAPSE_STORAGE_KEY = 'siliconx-nav-collapsed-v2';

export const PILLAR_MEMORY_KEY = 'siliconx-pillar-last-route';

/**
 * SIL-566 (I2-B4) — per-pillar nav memory. Session-scoped ONLY:
 * `sessionStorage`, not `localStorage`, so it survives in-session navigation
 * (including reload) but resets on a new browser session, and each tab gets
 * its own memory, matching the acceptance criteria verbatim. Recorded on
 * every route change (the `pathname`/`activePillar` effect in AppShell) and
 * consulted by `handlePillarClick` so re-clicking a rail button returns to
 * the last page visited in that pillar instead of always resetting to its
 * first item.
 */
// Exported (not just component-internal) so `dual-profile-nav.test.ts` can
// exercise the sessionStorage round-trip and the target-resolution rule
// directly, without standing up a full AppShell render (router/auth/
// react-query context this component depends on).
export function readPillarMemory(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(PILLAR_MEMORY_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch {
    return {};
  }
}

export function writePillarMemory(pillar: string, path: string) {
  if (typeof window === 'undefined') return;
  const mem = readPillarMemory();
  if (mem[pillar] === path) return; // skip a redundant write on every render
  mem[pillar] = path;
  window.sessionStorage.setItem(PILLAR_MEMORY_KEY, JSON.stringify(mem));
}

/**
 * The pillar-click target: the remembered route if it still resolves to one
 * of this pillar's CURRENT nav entries, else the pillar's first item (first
 * visit / stale memory from a moved-or-removed nav entry). Pulled out of
 * `handlePillarClick` as a pure function so the rule itself is unit-testable
 * without a component render.
 */
export function resolvePillarClickTarget(
  pillar: { items: { to: string }[] },
  remembered: string | undefined,
): string | undefined {
  const rememberedIsValid =
    !!remembered && pillar.items.some((item) => remembered === item.to || remembered.startsWith(`${item.to}/`));
  return rememberedIsValid ? remembered : pillar.items[0]?.to;
}
